import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { EntityState, Entity } from '../../types';
import { entityApi } from '../../services/entityApi';

const initialState: EntityState = {
  entities: [],
  isLoading: false,
  error: null,
};

export const fetchEntities = createAsyncThunk(
  'entities/fetchEntities',
  async (_, { rejectWithValue }) => {
    try {
      const response = await entityApi.getEntities();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch entities');
    }
  }
);

export const createEntity = createAsyncThunk(
  'entities/createEntity',
  async (entityData: any, { rejectWithValue }) => {
    try {
      const response = await entityApi.createEntity(entityData);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to create entity');
    }
  }
);

const entitySlice = createSlice({
  name: 'entities',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch entities
      .addCase(fetchEntities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEntities.fulfilled, (state, action: PayloadAction<Entity[]>) => {
        state.isLoading = false;
        state.entities = action.payload;
      })
      .addCase(fetchEntities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Create entity
      .addCase(createEntity.fulfilled, (state, action: PayloadAction<Entity>) => {
        state.entities.unshift(action.payload);
      });
  },
});

export const { clearError } = entitySlice.actions;
export default entitySlice.reducer;
